// extracted by mini-css-extract-plugin
export default {"section":"Stats_section__0AAI6","btn":"Stats_btn__5IXPP"};